import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { FaRegWindowMaximize } from "react-icons/fa";
import { GiRobotHelmet } from "react-icons/gi";
import BugReportModal from "../BugReportModal";
import ServiceProgramRobotIssueReportModal from "../ServiceProgramRobotIssueReportModal";
import ms from "../../../state-observables/modal/ModalState";
import { isSerialNumberRegistered } from "../../../utils/warranty-service/warranty-service-utils";
import { NewRobotIdE, useConnectedRafts } from "../../../store/SelectedRaftContext";
import SimpleButton from "../../disposables/buttons/SimpleButton";
import { RED } from "../../../styles/colors";

export default function ReportIssueModal() {
    const { t } = useTranslation();
    const [modalContent, setModalContent] = useState<"selector" | "robot-issue" | "app-issue">("selector");
    const [isRobotRegisteredInServiceProgram, setIsRobotRegisteredInServiceProgram] = useState<boolean>(false);

    const { connectedRafts } = useConnectedRafts();
    const selectedRaft = connectedRafts.find(connectedRaft => connectedRaft.isSelected && connectedRaft.id !== NewRobotIdE.NEW);

    useEffect(() => {
        const connectedRaft = window.applicationManager.connectedRafts[selectedRaft?.id || ""];
        if (connectedRaft) {
            const serialNumber = connectedRaft.getSerialNumber();
            isSerialNumberRegistered(serialNumber).then((isRegistered) => {
                setIsRobotRegisteredInServiceProgram(isRegistered);
            }).catch((err) => console.log(err));
        }
    }, []);

    let serialNumber = "";
    if (selectedRaft) {
        const connectedRaft = window.applicationManager.connectedRafts[selectedRaft.id];
        if (connectedRaft) {
            serialNumber = connectedRaft.getSerialNumber();
        }
    }

    let contentJSX = (<div className={styles.container}>
        <div className={styles.reportIssueContainer}>
            <h3>{t('report_issue.title')}</h3>
            <div className={styles.reportIssue}>
                <button
                    className={styles.reportIssueButton}
                    onClick={() => setModalContent("app-issue")}
                >
                    <FaRegWindowMaximize />
                    <h4>{t('report_issue.app_issue_title')}</h4>
                    <p>{t('report_issue.app_issue_desc')}</p>
                </button>

                <button
                    className={[styles.reportIssueButton, isRobotRegisteredInServiceProgram ? "" : styles.disabled].join(" ")}
                    disabled={!isRobotRegisteredInServiceProgram}
                    onClick={() => setModalContent("robot-issue")}
                ><GiRobotHelmet />
                    <h4>{t('report_issue.robot_issue_title')}</h4>
                    {isRobotRegisteredInServiceProgram ? <p>{t('report_issue.robot_issue_desc')}</p> : <p>{t('report_issue.robot_issue_register')}</p>}
                </button>
            </div>
            <div className={styles.cancelButtonContainer}>
                <SimpleButton
                    titleSize="1.5rem"
                    title={t('report_issue.cancel')}
                    onClick={() => ms.closeModal()}
                    colour={RED}
                    otherStyles={{padding: "0.5rem 1rem" }}
                />
            </div>
        </div>
        {/* <button className={styles.button} onClick={() => ms.closeModal()}>
            {t('report_issue.cancel')}
        </button> */}
    </div>);

    if (modalContent === "app-issue") {
        contentJSX = <BugReportModal />;
    } else if (modalContent === "robot-issue") {
        // for the robot issue, we want to make sure that the user is registered in the service program
        contentJSX = <ServiceProgramRobotIssueReportModal martySerialNumber={serialNumber} />;
    }
    return contentJSX;

}
